import language from '../constants/language';

export default {
  install(Vue: any) {
    Vue.prototype.$language = language;
  }
};
